import { Paper, Typography, useTheme } from "@mui/material";

interface MessageBodySectionProps {
  body: string;
  isApproved: boolean;
}

export const MessageBodySection = ({
  body,
  isApproved,
}: MessageBodySectionProps) => {
  const theme = useTheme();

  // Don't show message body if approved
  if (isApproved) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: "10px",
        bgcolor: theme.palette.grey[50],
        mb: 0,
        borderRadius: 0.5,
      }}
    >
      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
        {body.length ? body : "No message body"}
      </Typography>
    </Paper>
  );
};
